import { createContext } from "react";

//#region src/components/sticky-footer/StickyFooterProviderContext.tsx
const StickyFooterProviderContext = createContext(null);

//#endregion
export { StickyFooterProviderContext };